<template>
  <div class="flex items-center gap-1" :class="{ 'justify-center': center }">
    <!-- h-10/w-10 gives each icon a real touch target without changing the
         visual rhythm (the icons themselves are unchanged). -->
    <button
      v-for="opt in voteOptions"
      :key="opt.value"
      type="button"
      class="flex h-10 w-10 items-center justify-center rounded-md transition disabled:cursor-wait"
      :class="
        currentVote === opt.value
          ? 'text-highlight'
          : 'text-muted opacity-75 hover:opacity-100'
      "
      :disabled="voting"
      :aria-pressed="currentVote === opt.value ? 'true' : 'false'"
      :aria-label="$t('vote.' + opt.value)"
      :title="$t('vote.' + opt.value)"
      @click.prevent="setVote(opt.value)"
    >
      <Font-awesome-icon
        :icon="[currentVote === opt.value ? 'fas' : 'far', opt.icon]"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: "SeriesVote",
  props: {
    // A tracked-series record from the store (carries `id`, `tmdbId`, `vote`).
    series: { required: true },
    // Center the buttons (for the centered-meta Dashboard cards).
    center: { type: Boolean, default: false },
  },

  data() {
    return {
      voting: false,
      voteOptions: [
        { value: "dislike", icon: "thumbs-down" },
        { value: "like", icon: "thumbs-up" },
        { value: "really_like", icon: "heart" },
      ],
    };
  },

  computed: {
    currentVote() {
      return this.series.vote ?? null;
    },
  },

  methods: {
    setVote(value) {
      // Clicking the active vote again clears it.
      const next = this.currentVote === value ? null : value;
      this.voting = true;
      // The vote endpoint keys on the TMDB id, not our local record id.
      this.$store
        .dispatch("vote", { seriesId: this.series.tmdbId, vote: next })
        .then(() => {
          // Persist onto the store record so it survives navigation and
          // re-renders reactively (keyed by the local record id).
          this.$store.commit("setSeriesRecord", { ...this.series, vote: next });
        })
        .catch(() => undefined)
        .finally(() => (this.voting = false));
    },
  },
};
</script>
